module.exports = __webpack_public_path__ + "static/media/sign.0c4876a6.png";